/**
 * Export form data to CSV file (opens in Excel with Arabic support)
 */

export type StringRecord = Record<string, string>;

const STORAGE_KEY_ADMISSIONS = 'cgot_admissions_data';
const STORAGE_KEY_CONTACT = 'cgot_contact_data';

// ────────────────────────────────────────────────────────────────────────────
// Storage helpers
// ────────────────────────────────────────────────────────────────────────────

export function saveAdmissionEntry(entry: StringRecord) {
  const existing = getAdmissionEntries();
  const newEntry: StringRecord = {
    ...entry,
    'تاريخ الإرسال': new Date().toLocaleString('ar-LY'),
  };
  existing.push(newEntry);
  localStorage.setItem(STORAGE_KEY_ADMISSIONS, JSON.stringify(existing));
  return newEntry;
}

export function getAdmissionEntries(): StringRecord[] {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY_ADMISSIONS) || '[]') as StringRecord[];
  } catch {
    return [];
  }
}

export function saveContactEntry(entry: StringRecord) {
  const existing = getContactEntries();
  const newEntry: StringRecord = {
    ...entry,
    'تاريخ الإرسال': new Date().toLocaleString('ar-LY'),
  };
  existing.push(newEntry);
  localStorage.setItem(STORAGE_KEY_CONTACT, JSON.stringify(existing));
  return newEntry;
}

export function getContactEntries(): StringRecord[] {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY_CONTACT) || '[]') as StringRecord[];
  } catch {
    return [];
  }
}

// ────────────────────────────────────────────────────────────────────────────
// CSV export (UTF-8 BOM so Excel reads Arabic correctly)
// ────────────────────────────────────────────────────────────────────────────

function toCsv(rows: StringRecord[]): string {
  if (rows.length === 0) return '';
  const headers = Object.keys(rows[0]);
  const headerRow = headers.map((h) => `"${h}"`).join(',');
  const dataRows = rows.map((row) =>
    headers.map((h) => `"${String(row[h] ?? '').replace(/"/g, '""')}"`).join(',')
  );
  return [headerRow, ...dataRows].join('\r\n');
}

function downloadCsv(content: string, filename: string) {
  const bom = '\uFEFF';
  const blob = new Blob([bom + content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function exportAdmissionsToExcel() {
  const data = getAdmissionEntries();
  if (data.length === 0) {
    alert('لا توجد بيانات طلبات تسجيل بعد.');
    return;
  }
  downloadCsv(toCsv(data), `طلبات_التسجيل_${new Date().toLocaleDateString('ar-LY').replace(/\//g, '-')}.csv`);
}

export function exportContactToExcel() {
  const data = getContactEntries();
  if (data.length === 0) {
    alert('لا توجد رسائل تواصل بعد.');
    return;
  }
  downloadCsv(toCsv(data), `رسائل_التواصل_${new Date().toLocaleDateString('ar-LY').replace(/\//g, '-')}.csv`);
}
